import { jsx as m } from "react/jsx-runtime";
import { forwardRef as n } from "react";
import { c as i } from "../../../index-BkVdNlfQ.js";
import '../../../index.css';import '../../../MarketDropdownContainer.css';/* empty css                      */
import p from "../styles/MarketDropdown.module.js";
const c = n((r, o) => {
  const {
    children: a,
    className: s,
    ...t
  } = r, e = i(
    p.marketDropdownContainer,
    s
  );
  return /* @__PURE__ */ m(
    "div",
    {
      ref: o,
      className: e,
      ...t,
      children: a
    }
  );
});
c.displayName = "MarketDropdownContainer";
export {
  c as MarketDropdownContainer
};
